import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { LinearProgress, Paper, Stack, Typography } from '@mui/material';

type PlanCounterProps = {
  title: string;
  fact: number;
  plan: number;
  compact?: boolean;
};

export const PlanCounter = ({ title, fact, plan, compact = false }: PlanCounterProps) => {
  const hasPlan = plan > 0;
  const isDone = hasPlan && fact >= plan;
  const palette = isDone ? 'success' : 'error';
  const progress = hasPlan ? Math.min(100, (fact / plan) * 100) : 0;

  return (
    <Paper
      variant="outlined"
      sx={{
        flex: 1,
        minWidth: compact ? 220 : undefined,
        maxWidth: compact ? 320 : undefined,
        p: 2,
        borderColor: hasPlan ? (theme) => theme.palette[palette].main : undefined
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
        <Typography variant="overline" color="text.secondary">{title}</Typography>
        {isDone && <CheckCircleOutlineIcon color="success" fontSize="small" />}
      </Stack>
      <Typography variant="h5" color={hasPlan ? `${palette}.main` : 'text.secondary'}>
        {fact} / {hasPlan ? plan : '—'}
      </Typography>
      <LinearProgress
        variant="determinate"
        value={progress}
        color={hasPlan ? palette : 'inherit'}
        sx={{ mt: 1, height: 6, borderRadius: 3, opacity: hasPlan ? 1 : 0.3 }}
      />
      {!hasPlan && !compact && <Typography variant="caption" color="text.secondary">План не установлен</Typography>}
    </Paper>
  );
};

export const PlanInfoCard = ({ title, value }: { title: string; value: number }) => (
  <Paper variant="outlined" sx={{ flex: 1, p: 2 }}>
    <Typography variant="overline" color="text.secondary">{title}</Typography>
    <Typography variant="h5">{value}</Typography>
  </Paper>
);
